import {
    legacy_createStore as createStore,
    applyMiddleware,
    combineReducers,
} from 'redux';
import thunk from 'redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import { composeWithDevTools } from '@redux-devtools/extension';
import storage from 'redux-persist/lib/storage';
import LogRocket from 'logrocket';
import sandboxReducer from '../TheBot/Sandbox/Redux/sandboxReducer';
import { phioReducer } from './phio/phioReducer';
import phioActionTypes from './phio/phioActionTypes';
import notificationReducer from './notification/notificationReducer';
import triageRegistrationConfigReducer from './triageRegistrationConfig/triageRegistrationConfigReducer';
import webUiConfigReducer from './webUiConfig/webUiConfigReducer';

const config = {
    key: 'root',
    storage,
    whitelist: ['phioReducer', 'webUiConfigReducer', 'sandboxReducer'],
    blacklist: ['notificationReducer', 'triageRegistrationConfigReducer'],
};

const rootReducer = combineReducers({
    phioReducer,
    notificationReducer,
    triageRegistrationConfigReducer,
    sandboxReducer,
    webUiConfigReducer,
});

const persistedReducer = persistReducer(config, rootReducer);
const store = createStore(
    persistedReducer,
    undefined,
    composeWithDevTools(applyMiddleware(thunk, LogRocket.reduxMiddleware())),
);

export const persistor = persistStore(store);

export const resetStore = () => {
    store.dispatch({
        type: phioActionTypes.RESET_PHIO_REDUCER,
    });
};

export default store;
